import { render, staticRenderFns } from "./modalVerImagen.vue?vue&type=template&id=2a548802&scoped=true"
import script from "./modalVerImagen.vue?vue&type=script&lang=js"
export * from "./modalVerImagen.vue?vue&type=script&lang=js"
import style0 from "./modalVerImagen.vue?vue&type=style&index=0&id=2a548802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a548802",
  null
  
)

export default component.exports